<template>
    <el-container class="index">
        <el-container>
            <el-aside :style="{ width: isCollapse ? '71px' : '200px' }" v-loading="loading">
                <div class="logo-div" @click="goDashboard()" v-show="!systemNameShow">
                    <img src="../assets/images/spotlight_logo.png" alt="" />
                    <!-- <p>报告生产平台</p> -->
                </div>
                <div class="logo-div-img" @click="goDashboard()" v-show="systemNameShow">
                    <img src="../assets/images/istarshine_logo.png" alt="" />
                    <!-- <p>报告</p> -->
                </div>
                <el-menu
                    :default-active="index"
                    background-color="transparent"
                    :default-openeds="openArr"
                    class="el-menu-vertical-demo"
                    active-text-color="#fff"
                    :unique-opened="true"
                    text-color="#fff"
                    :collapse="isCollapse"
                >
                    <template v-for="(item, index) in sysMenuList">
                        <el-menu-item v-if="!item.submenuList" :index="menuIndexDic[item.name]" class="pl21" @click="goPage(menuIndexDic[item.name], item.url)">
                            <i class="inblock w16 starand-box f15" :class="item.icon"></i>
                            <span slot="title" style="margin-left: 8px;">{{ item.name }}</span>
                        </el-menu-item>
                        <el-submenu
                            v-else
                            :class="{
                                'title-level1-open': !isCollapse,
                                'title-level1-close': isCollapse
                            }"
                            :index="menuIndexDic[item.name] || `${item.id}`"
                        >
                            <template slot="title">
                                <i class="inblock w16 starand-box f15" :class="item.icon"></i>
                                <span>{{ item.name }}</span>
                            </template>
                            <el-menu-item v-for="(item1, index1) in item.submenuList" :index="menuIndexDic[item1.name]" :key="item1.id" @click="goPage(menuIndexDic[item1.name], item1.url)">
                                <span class="inblock w16" :class="isCollapse ? 'hide' : 'show'"></span>
                                <span slot="title" style="margin-left: 0;">{{ item1.name }}</span>
                            </el-menu-item>
                        </el-submenu>
                    </template>
                </el-menu>
            </el-aside>
            <el-main>
                <div class="sub_container">
                    <header-page></header-page>
                    <router-view :key="$route.fullPath" @refreshMenu="refreshMenu"></router-view>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
    import '@/assets/css/index.css'
    import '@/assets/fonts/iconfont.css'
    import { getMenuList, getSystemRouter } from '@r/api'
    import { isExistInRoutes, isExternalLink } from '@/util/common'
    import { EventBus } from '@/assets/js/event-bus'
    import { routes } from '@/router/index'
    export default {
        data() {
            let defaultMenuIndexDic = {}
            routes.forEach(item => {
                if (item.children && Array.isArray(item.children)) {
                    item.children.forEach(item1 => {
                        defaultMenuIndexDic[item1.meta.name] = item1.name
                    })
                }
            })
            return {
                isCollapse: false,
                systemNameShow: false,
                userInfo: '',
                openArr: ['1'],
                menuList: [],
                sysMenuList: [],
                menuIndexDic: defaultMenuIndexDic,
                menuIndex: '',
                allReportMenuShowFlag: false,
                loading: false,
                showGroup: false,
                showFileConverter: false // 是否有导入excel导出word模块访问权限
            }
        },
        computed: {
            key() {
                return this.$route.path + Math.random()
            },
            index: {
                get() {
                    return this.$route.name
                },
                set() {}
            }
        },
        watch: {
            '$route.path': {
                handler() {
                    if (sessionStorage.getItem('index')) {
                        this.$store.commit('menuIndex', sessionStorage.getItem('index'))
                    }
                }
            }
        },
        created() {
            var width = window.screen.width
            if (width <= 1600) {
                this.extend()
            }
        },
        mounted() {
            // if (sessionStorage.getItem('index') != undefined) {
            //     this.index = sessionStorage.getItem('index')
            // }
            if (this.$route.name) {
                this.index = this.$route.name
                sessionStorage.setItem('index', this.$route.name)
                this.$store.commit('menuIndex', this.$route.name)
            }
            this.userInfo = this.$cookies.get('user_info') || {}
            //部分用户给分配全部报告列表的页面权限
            this.allReportMenuShowFlag =
                ['10178', '11525', '10211', '10117', '10174', '10134', '12286', '12398', '12375'].indexOf(
                    this.userInfo.userid
                ) > -1
            // this.allReportMenuShowFlag = true
            this.showFileConverter = true

            if (sessionStorage.getItem('index')) {
                this.$store.commit('menuIndex', sessionStorage.getItem('index'))
            }
            // this.initMenu()
            this.initRouterMenu()
            EventBus.$on('changeMenuExtend', () => {
                this.extend()
            })
            this.handleResize()
        },
        methods: {
            initRouterMenu() {
                getSystemRouter({}).then(res => {
                    if (res.list && Array.isArray(res.list) &&  res.list.length > 0) {
                        let sysMenuList = res.list
                        this.sysMenuList = this.deepCopyAndFilter(sysMenuList)
                    } else if (res.list && Array.isArray(res.list) &&  res.list.length === 0) {
                        this.$message({ type: 'info',dangerouslyUseHTMLString: true, message: '暂无制作报告权限，请移步右上角<i class="el-icon-headset"></i>寻求管理员帮助' })
                    }
                })
            },
            deepCopyAndFilter(arr) {
                return arr.reduce((res, item) => {
                    if (item.visible === 1) {
                        const newObj = { ...item }
                        if (newObj.submenuList && Array.isArray(newObj.submenuList)) {
                            newObj.submenuList = this.deepCopyAndFilter(newObj.submenuList)
                        }
                        res.push(newObj)
                    }
                    return res
                }, [])
            },
            initMenu() {
                this.loading = true
                getMenuList({}).then(data => {
                    if (data && data.list) {
                        this.loading = false
                        let list = data.list
                        sessionStorage.setItem('menuList', JSON.stringify(list)) //判断页面路由权限需要用到
                        list = this.getVisibleMenu(list)
                        //存储一个左侧导航对应的本地页面 name 集合数组
                        let routesNames = JSON.parse(sessionStorage.getItem('routes_names'))
                        let menuNames = this.getMenuNames(list, routesNames)
                        sessionStorage.setItem('menu_names', JSON.stringify(menuNames))
                        let menuList = []
                        let groups = []
                        for (let index = 0; index < list.length; index++) {
                            const element = list[index]
                            let group = element.group
                            if (group && !groups.includes(group)) {
                                groups.push(group)
                            }
                        }
                        if (groups.length != list.length) {
                            groups.unshift('#UNCLASSIFIED')
                        }
                        if (groups.length > 1) {
                            this.showGroup = true
                        }
                        for (let index = 0; index < groups.length; index++) {
                            const element = groups[index]
                            menuList.push({
                                id: 'group' + index,
                                group: element,
                                submenuList: []
                            })
                        }

                        for (let index = 0; index < list.length; index++) {
                            const groupItem = list[index]
                            let groupIndex = groups.findIndex(value => value == groupItem.group)
                            if (groupIndex == -1) {
                                groupIndex = 0
                            }
                            let submenuList = menuList[groupIndex].submenuList
                            submenuList.push(groupItem)
                            menuList[groupIndex].submenuList = submenuList
                        }
                        this.menuList = menuList
                    }
                })
            },
            handleResize() {
                const getWindowInfo = () => {
                    const windowInfo = {
                        width: window.innerWidth,
                        hight: window.innerHeight
                    }
                    let isCollapse = windowInfo.width <= 1600
                    this.changeMenuStatus(isCollapse)
                }
                const debounce = (fn, delay) => {
                    let timer
                    return function() {
                        if (timer) {
                            clearTimeout(timer)
                        }
                        timer = setTimeout(() => {
                            fn()
                        }, delay)
                    }
                }
                this.cancelDebounce = debounce(getWindowInfo, 500)
                window.addEventListener('resize', this.cancelDebounce)
            },
            /**
             * 去除隐藏的左侧导航菜单， visible: 1 显示
             * FIXME: 先不考虑三级菜单
             */
            getVisibleMenu(list) {
                let menuList = []
                for (let index = 0; index < list.length; index++) {
                    const element = list[index]
                    if (element.visible == 1) {
                        if (element.submenuList && element.submenuList.length > 0) {
                            let submenuList = []
                            element.submenuList.forEach(subMenu => {
                                if (subMenu.visible == 1) {
                                    submenuList.push(subMenu)
                                }
                            })
                            element.submenuList = submenuList
                        }
                        menuList.push(element)
                    }
                }
                return menuList
            },
            goPage(index, router) {
                sessionStorage.setItem('index', index)
                this.$store.commit('menuIndex', sessionStorage.getItem('index'))
                this.$router.push({ path: router })
            },
            goRouter(item, parentGroup) {
                if (isExternalLink(item.url)) {
                    //如果路径为外部页面链接，
                    window.open(item.url)
                    return
                } else if (!item.url || !isExistInRoutes(item.url)) {
                    //如果路径为空或者未在本地路由菜单列表中找到，提示 “当前页面正在建设中”
                    this.$message({
                        message: '当前页面正在建设中',
                        type: 'warning',
                        duration: 1000
                    })
                    return
                }
                sessionStorage.setItem('index', item.url)
                this.$store.commit('menuIndex', sessionStorage.getItem('index'))
                this.$router.push({ name: item.url })
            },
            changeMenuStatus(isCollapse) {
                this.isCollapse = isCollapse
                this.systemNameShow = isCollapse
                EventBus.$emit('resize')
            },
            // 展开收起
            extend() {
                this.isCollapse = !this.isCollapse
                setTimeout(() => {
                    this.systemNameShow = !this.systemNameShow
                    EventBus.$emit('isCollapse', this.isCollapse)
                    EventBus.$emit('resize')
                }, 200)
            },
            goDashboard() {
                this.$store.commit('menuIndex', 'dashboard')
                this.$router.push({ path: '/dashboard' })
            },
            goReport() {
                this.$store.commit('menuIndex', 'reportDetail')
                this.$router.push({ path: '/report/detail' })
            },
            refreshMenu() {
                this.initMenu()
            },
            /**
             * 获取左侧导航菜单中，对应的本地页面路由 name 数组
             */
            getMenuNames(menuList = [], routesNames) {
                let names = []
                for (let index = 0; index < menuList.length; index++) {
                    const element = menuList[index]
                    if (element.submenuList && element.submenuList.length > 0) {
                        names = names.concat(this.getMenuNames(element.submenuList, routesNames))
                    }
                    //判断是否未子节点, 并且存在于本地 routes 中
                    if (element.leaf == 1 && routesNames.includes(element.url)) {
                        names.push(element.url)
                    }
                }
                return names
            }
        },
        destroyed() {
            window.removeEventListener('resize', this.cancelDebounce)
        }
    }
</script>
<style lang="scss" scoped>
.inblock {
    display: inline-block;
}
.w16 {
    width: 16px;
}
.starand-box::before {
    margin: 0 !important;
    width: 16px;
    height: 16px;
}
.hide {
    display: none;
}
.show {
    display: inline-block;
}
.el-menu-vertical-demo /deep/ .el-menu-item .el-tooltip {
    padding-left: 23px !important;
}
.el-menu-vertical-demo /deep/ .el-menu-item.pl21.is-active .el-tooltip {
    padding-left: 21px !important;
}
#app /deep/ .el-menu-vertical-demo > .pl21.is-active {
    padding-left: 19px !important;
}
</style>
<style>
    #app .index .pl21 {
        padding-left: 21px !important;
    }
    #app .index .pl21.is-active {
        padding-left: 19px !important;
    }
    .index .el-submenu__title .iconfont,.f15 {
        font-size: 15px;
    }
    .el-menu-item-group__title {
        padding-left: 0 !important;
        padding-right: 0;
    }
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
    }
    .el-menu-vertical-demo .title-level1-open.el-submenu .el-submenu__title {
        height: 42px;
        line-height: 42px;
        padding-left: 21px !important;
    }
    .el-menu-vertical-demo .title-level1-close.el-submenu .el-submenu__title {
        height: 42px;
        line-height: 42px;
    }
    .el-menu-vertical-demo .el-menu--inline .el-menu-item.is-active {
        border-left: 3px solid #5FBBFF;
    }
    .m-icon-default:before {
        color: #ffffff;
    }
    .icon-team.m-icon-default:before {
        font-size: 18px;
        margin-left: 2px;
        margin-right: 8px;
    }
    .el-menu-item.is-active .el-tooltip {
        padding-left: 19px !important;
    }
    .el-menu--inline span,
    .el-submenu__title span,
    .el-menu-item span {
        padding-left: 14px;
    }
    .el-submenu,
    .el-menu-item {
        margin-top: 8px;
    }
    .el-menu--vertical[x-placement] .el-menu-item {
        text-align: center;
    }
    .el-menu--vertical[x-placement] .el-menu-item span {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/views/index.vue